module.exports = __webpack_public_path__ + "img/logo_AboutUs3_Mobile.d2e640be.png";